import "./multirangeslider.css";
import { Outlet } from "react-router-dom";
import TopNav from "./Components/Navigation/TopNav";
import SideNav from "./Components/Navigation/SideNav";
import { useAppDispatch, useAppSelector } from "./Reducers/store";
import {
  fetchCategories,
  fetchEquipmentSearchData,
  fetchSubCategories,
} from "./Actions/CommonFields";
import { useEffect, useState } from "react";
import Footer from "./Components/Navigation/Footer";
import { UserLevelNames } from "./Models/UserLevel";
import Loader from "./Components/Common/Loader";

function App() {
  const dispatch = useAppDispatch();
  const { userModel } = useAppSelector((state) => state.user);
  const { manufacturers, categories, subCategories, equipmentSearchData } =
    useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getReferences = async () => {
    if (
      !manufacturers.length ||
      !categories ||
      !subCategories ||
      !equipmentSearchData
    ) {
      await Promise.all([
        dispatch(fetchCategories()),
        dispatch(fetchSubCategories()),
        dispatch(fetchEquipmentSearchData()),
      ]);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getReferences();
    setIsLoading(false);
  }, []);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        {/* Header */}
        <TopNav />

        {/* Scrollable content area */}
        <div className="flex flex-1 overflow-hidden">
          {userModel?.userLevelId === UserLevelNames.Admin ||
          userModel?.userLevelId === UserLevelNames.Employee ? (
            <SideNav />
          ) : null}

          <div className="flex-1 overflow-y-auto">
            <Outlet />
          </div>
        </div>

        {/* Footer pinned to bottom */}
        <Footer />
      </div>
    </>
  );
}

export default App;
